export default {
  methods: {
    formatCompact(num = 0, opts = { decimals: 2, useSeparator: false }) {
      const { decimals = 2, useSeparator = false } = opts

      const sign = num < 0 ? '-' : ''
      const abs = Math.abs(num)

      const thresholds = [
        { value: 1e12, suffix: 'T' }, // trillion
        { value: 1e9, suffix: 'B' }, // billion
        { value: 1e6, suffix: 'M' }, // million
        { value: 1e3, suffix: 'K' } // thousand
      ]

      // If number is smaller than 1000, show plain (optionally with separators)
      if (abs < 1000) {
        if (useSeparator) {
          return sign + new Intl.NumberFormat().format(abs)
        }
        // Remove trailing .0 for integers (e.g. 950 -> "950")
        return sign + (Number.isInteger(abs) ? String(abs) : String(abs))
      }

      for (const t of thresholds) {
        if (abs >= t.value) {
          const value = abs / t.value
          // format with max decimals, then strip trailing zeros and dot
          const formatted = value.toFixed(decimals).replace(/\.?0+$/, '')
          return sign + formatted + t.suffix
        }
      }

      // fallback (shouldn't hit)
      return sign + String(num)
    }
  }
}
